/*
 * Copyright (c) 2012-present Sedicii Innovations Ltd.
 *
 * All rights reserved.
 */

import {
  KYC_LOGIN_RESET,
  KYC_LOGIN_FORM_ERROR,
  KYC_LOGIN_FORM_SUBMIT,
  KYC_LOGIN_MFA_PENDING,
  KYC_LOGIN_MFA_SUCCESS,
  KYC_LOGIN_MFA_FAILURE,
  KYC_LOGIN_LOGOUT,
  KYC_LOGIN_SYNC
} from '../actions/kycLogin'

const defaultState = {
  isAuthenticated: false,
  token: null,
  userId: null
}

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case KYC_LOGIN_RESET:
    case KYC_LOGIN_FORM_ERROR:
    case KYC_LOGIN_FORM_SUBMIT:
    case KYC_LOGIN_MFA_PENDING:
    case KYC_LOGIN_MFA_FAILURE:
    case KYC_LOGIN_LOGOUT:
      return defaultState
    case KYC_LOGIN_MFA_SUCCESS:
      return {
        isAuthenticated: true,
        token: payload.id_token,
        userId: payload.user.id
      }
    case KYC_LOGIN_SYNC:
      return {
        ...defaultState,
        ...payload
      }
    default:
      return state
  }
}
